let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kgkaG")).then(() => parcelRequire('3pX63'));